import { isPaymentsApiSuccess, verifyDummyPayment } from '../../services/paymentsApi';

export const RAZORPAY_CHECKOUT_SRC = 'https://checkout.razorpay.com/v1/checkout.js';

let loader;

export function loadRazorpay() {
  if (typeof window !== 'undefined' && window.Razorpay) return Promise.resolve();
  if (loader) return loader;
  loader = new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = RAZORPAY_CHECKOUT_SRC;
    script.onload = () => resolve();
    script.onerror = () => {
      loader = null;
      reject(new Error('Could not load Razorpay'));
    };
    document.body.appendChild(script);
  });
  return loader;
}

/** Only the publishable key id is passed through. The key secret is never copied onto this object. */
export function razorpayOptions(order, handler, ondismiss) {
  return {
    key: order.key_id,
    order_id: order.order_id,
    amount: order.amount,
    currency: order.currency,
    name: 'Dugout',
    description: `Dummy ${order.receipt}`,
    handler,
    modal: { ondismiss },
  };
}

export function openRazorpay(order, verifyPayment = verifyDummyPayment) {
  return new Promise((resolve, reject) => {
    let settled = false;
    let handlerStarted = false;
    const settle = (action, value) => {
      if (settled) return;
      settled = true;
      if (action === 'resolve') resolve(value);
      else reject(value);
    };

    const options = razorpayOptions(
      order,
      async (response) => {
        handlerStarted = true;
        try {
          const verified = await verifyPayment({
            razorpay_payment_id: response.razorpay_payment_id,
            razorpay_order_id: response.razorpay_order_id,
            razorpay_signature: response.razorpay_signature,
          });
          if (isPaymentsApiSuccess(verified) && verified?.data?.verified === true) {
            settle('resolve', verified.data);
          } else {
            settle('reject', new Error(verified?.message || 'Verify failed'));
          }
        } catch (error) {
          settle('reject', error instanceof Error ? error : new Error('Verify failed'));
        }
      },
      () => {
        if (handlerStarted) return;
        settle('reject', new Error('cancelled'));
      }
    );

    const rzp = new window.Razorpay(options);
    rzp.open();
  });
}
